import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../common/Modal';
import Icon, { GLYPHS } from '../../../../common/icon';
import Products from '../../../../register/sale/containers/Products';
import OrderInfo from '../../../../register/sale/containers/OrderInfo';
import CheckoutSale from '../../../../register/payment/containers/CheckoutSale';
import ProductSaleChargeButton from '../../../../register/sale/containers/ProductSaleChargeButton';
import ProductSaleChargeAmount from '../../../../register/payment/containers/ProductSaleChargeAmount';
import BarcodeScannerListener from '../../../../register/sale/containers/BarcodeScannerListener';

const ProductSale = ({ close }) => {
  const BackButton = () => (
    <div>
      <button type="button" className="c-btn c-btn--blank u-mr" onClick={close}>
        <Icon glyph={GLYPHS.arrowCircle} size="medium" className="c-back-circle-icon" />
      </button>
      <span className="c-heading c-heading--light">
        Add Products
      </span>
    </div>
  );

  return (
    <Modal close={close} BackButton={BackButton}>
      <BarcodeScannerListener />
      <div className="c-appointment-product-sale">
        <div className="c-register-layout">
          <CheckoutSale />
          <ProductSaleChargeAmount />
          <div className="c-register-layout__main">
            <Products />
          </div>
          <div className="c-register-layout__sidebar">
            <div className="u-flex-1 u-co-gray-2 epsilon u-type--light">
              <OrderInfo />
            </div>
            <div className="c-register-charge-button">
              <ProductSaleChargeButton />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

ProductSale.propTypes = {
  close: PropTypes.func.isRequired,
};

export default ProductSale;
